import type { IssueParent } from '../../../../model/issue-parent/types.tsx';

export const ISSUE_PARENT_PATCH = 'state.actions.issue-parents.patch.ISSUE_PARENT_PATCH';

type IssueParentPatchPayload = {
	id: string;
	issueParent: Partial<IssueParent>;
};

export type IssueParentPatchAction = {
	type: typeof ISSUE_PARENT_PATCH;
	payload: IssueParentPatchPayload;
};

/**
 * Patch a Redux local issue parent state.
 */
export const issueParentPatch = (payload: IssueParentPatchPayload): IssueParentPatchAction => ({
	type: ISSUE_PARENT_PATCH,
	payload,
});

export type Action = IssueParentPatchAction;
